/* StudioSoie · bulle du chat SAV réductible / masquable (run 11), sans toucher à assets/ss-chat.js (AI Solver).
   - Ordinateur : la pastille « Besoin d'aide ? » se réduit à l'icône dès qu'on fait défiler la page (revient en haut de page).
   - Partout : petite croix « Masquer l'assistant » → la bulle laisse place à un onglet discret au bord droit de l'écran ;
     un clic sur l'onglet fait revenir la bulle. Choix mémorisé (localStorage « ss_chat_dock », repli : session en cours).
   - Les liens « #chat » / [data-ss-chat] ouvrent toujours le chat, même bulle masquée. */
(function () {
  'use strict';
  if (window.__ssChatDock) { return; }
  window.__ssChatDock = true;
  var T = window.SS_CHAT_DOCK_T || {};
  var L_HIDE = T.hide || 'Masquer l’assistant', L_SHOW = T.show || 'Afficher l’assistant';
  var KEY = 'ss_chat_dock';
  var mem = '';
  function get() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return mem; } }
  function set(v) { mem = v; try { if (v) { localStorage.setItem(KEY, v); } else { localStorage.removeItem(KEY); } } catch (e) {} }

  var css = '' +
    '.ssc-root .ssc-launcher{transition:transform .3s cubic-bezier(.2,.7,.2,1),opacity .25s ease,width .3s ease,padding .3s ease}' +
    '@media (min-width:561px){.ssc-root.ssd-compact:not(.is-open) .ssc-launcher{width:52px;padding:0;justify-content:center;gap:0}.ssc-root.ssd-compact .ssc-launcher span{display:none}}' +
    '@media (max-width:560px){.ssc-root.ssd-compact:not(.is-open) .ssc-launcher{width:46px;height:46px}.ssc-root.ssd-compact .ssc-launcher svg{width:18px;height:18px}}' +
    '.ssc-root.ssd-docked:not(.is-open) .ssc-launcher{opacity:0;pointer-events:none;transform:translateX(140%)}' +
    '.ssd-x{position:fixed;z-index:2147483001;width:24px;height:24px;padding:0;margin:0;border-radius:999px;border:1px solid #e8e4df;background:#fff;color:#6b6259;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 4px 12px rgba(26,26,26,.18);opacity:0;transform:scale(.8);pointer-events:none;transition:opacity .2s ease,transform .2s ease,background .2s,color .2s}' +
    '.ssd-x::before{content:"";position:absolute;inset:-2px}' +
    '.ssd-x svg{width:10px;height:10px;display:block}' +
    '.ssd-x.is-on{opacity:1;transform:none;pointer-events:auto}' +
    '.ssd-x:hover,.ssd-x:focus-visible{background:#1a1a1a;color:#faf8f5;border-color:#1a1a1a}' +
    '.ssd-tab{position:fixed;right:0;z-index:2147483000;width:30px;height:48px;padding:0 0 0 2px;margin:0;border:1px solid #1a1a1a;border-right:0;border-radius:14px 0 0 14px;background:#1a1a1a;color:#faf8f5;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 8px 24px rgba(26,26,26,.25);transform:translateX(110%);transition:transform .3s cubic-bezier(.2,.7,.2,1),width .2s ease,background .2s}' +
    '.ssd-tab svg{width:16px;height:16px;display:block}' +
    '.ssd-tab.is-on{transform:none}' +
    '.ssd-tab:hover,.ssd-tab:focus-visible{width:38px;background:#8b6f4e;border-color:#8b6f4e}' +
    '.ssc-root.is-open ~ .ssd-x,.ssc-root.is-open ~ .ssd-tab{display:none}' +
    '@media (prefers-reduced-motion:reduce){.ssc-root .ssc-launcher,.ssd-x,.ssd-tab{transition:none}}';

  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.6A8 8 0 1 1 21 12z"/></svg>';

  function init(root, launcher) {
    var st = document.createElement('style'); st.id = 'ssd-style'; st.textContent = css; document.head.appendChild(st);
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'ssd-x'; x.setAttribute('aria-label', L_HIDE); x.title = L_HIDE; x.innerHTML = ICON_X;
    var tab = document.createElement('button');
    tab.type = 'button'; tab.className = 'ssd-tab'; tab.setAttribute('aria-label', L_SHOW); tab.title = L_SHOW; tab.innerHTML = ICON_CHAT;
    root.parentNode.insertBefore(x, root.nextSibling);
    root.parentNode.insertBefore(tab, x.nextSibling);
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var hoverOn = false, hideT = null;

    function place() {
      var r = launcher.getBoundingClientRect();
      if (!r.width) { return; }
      x.style.left = Math.max(4, r.left - 15) + 'px';
      x.style.top = Math.max(4, r.top - 15) + 'px';
      tab.style.bottom = Math.max(8, window.innerHeight - r.bottom + 4) + 'px';
    }
    function sync() {
      var docked = get() === 'docked';
      root.classList.toggle('ssd-docked', docked);
      tab.classList.toggle('is-on', docked);
      x.classList.toggle('is-on', !docked && (touch || hoverOn));
      tab.tabIndex = docked ? 0 : -1;
      x.tabIndex = docked ? -1 : 0;
      place();
    }
    function compact() {
      var c = window.pageYOffset > 320;
      if (root.classList.contains('ssd-compact') !== c) { root.classList.toggle('ssd-compact', c); setTimeout(place, 320); }
    }
    function showX() { clearTimeout(hideT); hoverOn = true; sync(); }
    function hideXSoon() { clearTimeout(hideT); hideT = setTimeout(function () { hoverOn = false; sync(); }, 900); }
    [launcher, x].forEach(function (el) {
      el.addEventListener('mouseenter', showX); el.addEventListener('mouseleave', hideXSoon);
      el.addEventListener('focus', showX); el.addEventListener('blur', hideXSoon);
    });
    x.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      set('docked'); hoverOn = false; sync();
      try { tab.focus({ preventScroll: true }); } catch (er) {}
    });
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      set(''); sync();
      try { launcher.focus({ preventScroll: true }); } catch (er) {}
    });
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; compact(); }); } }, { passive: true });
    window.addEventListener('resize', place, { passive: true });
    launcher.addEventListener('transitionend', place);
    compact(); sync();
    setTimeout(place, 400);
  }

  function find() {
    var root = document.querySelector('.ssc-root'), l = root && root.querySelector('.ssc-launcher');
    if (root && l) { init(root, l); return true; }
    return false;
  }
  function start() {
    if (find()) { return; }
    if (!('MutationObserver' in window)) { return; }
    var mo = new MutationObserver(function () { if (find()) { mo.disconnect(); } });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
